import { ClearedOfferFileData } from "./shared/components/offer-summary-confirmation-dialog/clearedOfferFile";

const clearedOfferFileDataConst: ClearedOfferFileData = {
  name: "ECON-DR",
  date_time: new Date("2018-02-08T16:31:37"),
  date_time_label: "2018년02월08일\n16:31:37",
  loaded: true,
  error: false,
  saved: false,
  header: {
    resource: "자원명 // Resource",
    trading_date: "감축일자 // Trading Date",
    hour: "시간//hour",
    offered_volume: "입찰량(MWh) // Offered Volume",
    cleared_volume: "계획감축량(MWh) // Cleared Volume",
    percentage_cleared: "입찰평균단가(원/kWh) // Bidding price",
  },
  data: [
    {
      // 2 / x = 89.7, x = 2 / 0.897 = 2.23
      resource: "ENO-18I-N02",
      trading_date: "2018-02-08",
      hour: "9",
      offered_volume: "3.35",
      cleared_volume: "3.0",
      percentage_cleared: "89.7",
    },
    {
      resource: "ENO-18I-N02",
      trading_date: "2018-02-08",
      hour: "10",
      offered_volume: "2.23",
      cleared_volume: "2.0",
      percentage_cleared: "89.7",
    },
    {
      resource: "ENO-18I-N02",
      trading_date: "2018-02-08",
      hour: "11",
      offered_volume: "2.23",
      cleared_volume: "2.0",
      percentage_cleared: "89.7",
    },
    {
      resource: "ENO-18I-N02",
      trading_date: "2018-02-08",
      hour: "14",
      offered_volume: "2.23",
      cleared_volume: "2.0",
      percentage_cleared: "89.7",
    },
    {
      resource: "ENO-18I-N02",
      trading_date: "2018-02-08",
      hour: "15",
      offered_volume: "2.23",
      cleared_volume: "2.0",
      percentage_cleared: "89.7",
    },
    {
      resource: "ENO-18I-N02",
      trading_date: "2018-02-08",
      hour: "16",
      offered_volume: "3.35",
      cleared_volume: "3.0",
      percentage_cleared: "89.7",
    },
    {
      resource: "ENO-18I-N02",
      trading_date: "2018-02-08",
      hour: "17",
      offered_volume: "2.23",
      cleared_volume: "2.0",
      percentage_cleared: "89.7",
    },
  ],
};

export function GetData(): ClearedOfferFileData {
  return clearedOfferFileDataConst;
}



// WEBPACK FOOTER //
// ./src/app/cleared-offer-mock-data.ts